// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__X3Tkp","buttons":"styles_buttons__Etdix","disabled":"styles_disabled__VNTzd"};